import script from "./task-board-kanban.vue?vue&type=script&setup=true&lang=js"
export * from "./task-board-kanban.vue?vue&type=script&setup=true&lang=js"

import "./task-board-kanban.vue?vue&type=style&index=0&id=817b8878&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-817b8878"]])

export default __exports__